import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shown when the resume link is missing, invalid or expired
export const ResumeLinkExpired = ({ leadId }) => {
  const [status, setStatus] = useState('idle');

  const requestLink = async () => {
    setStatus('sending');
    try {
      await axios.post(`${API}/leads/${leadId}/resume-link`);
      setStatus('sent');
    } catch (err) {
      setStatus(err?.response?.status === 429 ? 'limited' : 'error');
    }
  };

  return (
    <div className="container mx-auto px-4 py-16 text-center max-w-xl" data-testid="resume-link-expired">
      <h1 className="text-2xl font-bold mb-3" style={{ color: '#01325B' }}>This link has expired or is no longer valid</h1>
      <p className="text-gray-700 mb-6">
        For your privacy, profile links are private and expire after 30 days. We can email a fresh link to the
        address you used when you first contacted us.
      </p>
      {status === 'sent' ? (
        <p className="text-green-800 bg-green-50 border border-green-200 rounded-lg px-4 py-3" data-testid="resume-link-sent">
          If we have this request on file, a new link is on its way to your email.
        </p>
      ) : (
        <button
          type="button"
          onClick={requestLink}
          disabled={status === 'sending'}
          data-testid="resume-link-request-btn"
          className="inline-block px-6 py-3 rounded-lg font-semibold text-white disabled:opacity-60"
          style={{ background: '#E07A2C' }}
        >
          {status === 'sending' ? 'Sending…' : 'Email Me a New Link'}
        </button>
      )}
      {(status === 'error' || status === 'limited') && (
        <p className="mt-4 text-sm text-red-700" data-testid="resume-link-error">
          {status === 'limited' ? 'Too many requests — please wait a minute and try again.' : 'Something went wrong. Please try again or call (972) 292-8640.'}
        </p>
      )}
    </div>
  );
};
